module Meevo.Plugins.SecurityRoles {
  "use strict";

  /**
  * Main Section of SecurityRole 
  */  //
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.SecurityRole> {
      public _modalService: any;
      public newAddSmartCenterDetail: Model.SmartCenterDetail;
      public maxNumberOfDaysToEditTransaction: number;

      constructor(
          sectionId: number,
          displayNameContentKey: string,
          template: string,
          isPrimarySection: boolean,
          handlesOwnCrud: boolean,
          baseEndpoint: string,
          sectionEndpoint: string,
          loggingService: Meevo.Components.Logging.ILoggingService,
          dataService: Meevo.Components.BaseClasses.IDataService,
          protected identityService: Meevo.Components.Common.IIdentityService = null,
          noun: Meevo.Model.NounEnum = null,
          appSettings?: Components.Common.IAppSettings,
          sectionSecurityKey?: string,
          protected modalService?: Meevo.Components.Modal.IModalService

      ) {
         
          super(sectionId,
              displayNameContentKey,
              template,
              isPrimarySection,
              handlesOwnCrud,
              baseEndpoint,
              sectionEndpoint,
              loggingService,
              dataService,
              identityService,
              noun,
              appSettings,
              sectionSecurityKey);

         // this._modalService = modalService;
          this.maxNumberOfDaysToEditTransaction = appSettings.APP_BUSINFOSETTINGS.registerSettings.maxNumberOfDaysToEditTransaction;
      }


    createSectionModelInstance(postAdd: (data: any) => any): void {
      this.dataService.getTemplate(this.baseEndpoint).then((data) => {
          this.model = data;
          
        // TODO: Need to initialize context.userListAvailable
        //this.userListAvailable = model.availableUsers;  
      });
      }

      addSmartCenter(smartCenter: Model.SmartCenterDetail): void {

          if(this.model.smartCenters.length < 5)
          {

              if (Model.Guard.isNothing(smartCenter))
                  return;

              if (Model.Guard.isNothing(this.model.smartCenters)) {
                  this.model.smartCenters = [];
              }
              if (_.any(this.model.smartCenters, (sr) => { return sr.id === smartCenter.id }))
                  return;
              var maxIndex = Math.max.apply(Math, this.model.smartCenters.map(function (o) { return o.position; }));
              var smartCenterDetail: Model.SmartCenterDetail = {
                  id: smartCenter.id,
                  displayName: smartCenter.displayName,
                  position: maxIndex + 1
              };

              this.model.smartCenters.push(smartCenterDetail);
              this.newAddSmartCenterDetail = undefined;

              this.model.smartCenters = this.updateSmartCenterList(this.model.smartCenters);
          }
          else
          {
              this.modalService.alert("MESSAGE_LIMIT_SMARTCENTER", Meevo.Components.Modal.ModalTranslationModes.Translate);
              this.newAddSmartCenterDetail = undefined;
          }

      }


      removeSmartCenter(index: number, item: any): void {

          if (Model.Guard.isSomething(this.model.smartCenters)) {
              var i = this.model.smartCenters.indexOf(item);

              if (i != -1) {
                  this.model.smartCenters.splice(i, 1);
              }
          }
          this.model.smartCenters = this.updateSmartCenterList(this.model.smartCenters);
      }
      updateSmartCenterList = (array: any) => {
          array = _.sortBy(array, 'position');
          for (var a = 0; a < array.length; a++) {
              array[a].position = a + 1;
          }
          array = _.sortBy(array, (item: any) => { return item.position });
          return array;
      }
      switch = (index1: number, index2: number, location: any) => {
          var array = this.model.smartCenters;
          if (array[index1] && array[index2]) {
              var temp = array[index2];
              var position1 = array[index1].position;
              var position2 = array[index2].position;
              array[index2] = array[index1];
              array[index1] = temp;
              array[index1].position = position1;
              array[index2].position = position2;
          }
          this.model.smartCenters = this.updateSmartCenterList(this.model.smartCenters);
      }
  }
}